// Prepositions, conjunctions, and articles that should remain lowercase in titles (unless at the start)
const LOWERCASE_WORDS = new Set([
  'a', 'an', 'the',
  'and', 'but', 'or', 'nor', 'for', 'so', 'yet',
  'as', 'at', 'by', 'in', 'of', 'off', 'on', 'per', 'to', 'up', 'via', 'with', 'from', 'into'
]);

// Known acronyms and abbreviations that should be fully uppercase
const KNOWN_ACRONYMS = new Set([
  'id', 'kyc', 'sms', 'otp', 'api', 'url', 'uri', 'ip', 'ui', 'ux', 'db',
  'ai', 'ml', 'sdk', 'sso', 'pdf', 'csv', 'faq', 'tos', 'pos', 'pan', 'gst',
  'hr', 'it', 'pr', 'gdpr', 'dpdp', 'hipaa', 'ccpa', 'dsar', 'dsr', 'pii',
  'uid', 'pin', 'nfc', 'rfid', 'uuid', 'mac', 'dns', 'ftp', 'ssl', 'tls',
  'http', 'https', 'json', 'xml', 'html', 'css', 'js', 'sql', 'b2b', 'b2c',
  'crm', 'erp', 'sla', 'nda', 'abdm'
]);

export const formatDisplayLabel = (value, fallback = '') => {
  const raw = String(value ?? '').trim();
  if (!raw) return fallback;

  return raw
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map((word, index) => {
      const lower = word.toLowerCase();
      const cleanWord = lower.replace(/^[^a-z0-9]+|[^a-z0-9]+$/gi, '');

      // Known acronyms (e.g. KYC, OTP, SMS, ID, API, GDPR) -> UPPERCASE
      if (cleanWord && KNOWN_ACRONYMS.has(cleanWord)) {
        return word.toUpperCase();
      }

      // Prepositions / conjunctions / articles (e.g. of, for, and, in, to, the)
      // If not the first word, display lowercase. If first word, capitalize.
      if (cleanWord && LOWERCASE_WORDS.has(cleanWord)) {
        if (index === 0) {
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }
        return word.toLowerCase();
      }

      // Standard Title Case: First letter uppercase, rest lowercase
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
};

export default formatDisplayLabel;

